import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, MapPin, Navigation } from 'lucide-react';
import { TransportOption } from '../components/TransportOption';
import { TimetableCard } from '../components/TimetableCard';
import { lastMileOptions, shipSchedules } from '../utils/mockData';
import { toBengaliNumeral } from '../utils/bengaliHelpers';
import { motion } from 'framer-motion';
export function PathFinderPage() {
  const navigate = useNavigate();
  const [selectedLastMile, setSelectedLastMile] = useState('opt_bus');
  const selectedOption = lastMileOptions.find(o => o.id === selectedLastMile);
  const totalMinFare = (selectedOption?.fareRange[0] || 0) + 350;
  const totalMaxFare = (selectedOption?.fareRange[1] || 0) + 350;
  return <div className="min-h-screen bg-gray-50 pb-32" data-id="element-296">
      {/* Header */}
      <div className="bg-[#006a4e] text-white sticky top-0 z-30 shadow-md" data-id="element-297">
        <div className="px-4 py-4 flex items-center space-x-3" data-id="element-298">
          <button onClick={() => navigate(-1)} className="p-2 hover:bg-white/10 rounded-full" data-id="element-299">
            <ArrowLeft size={24} data-id="element-300" />
          </button>
          <div data-id="element-301">
            <h1 className="font-bold font-bengali text-lg" data-id="element-302">আপনার যাত্রা রুট</h1>
            <p className="text-xs text-green-200 font-bengali" data-id="element-303">
              বাংলামটর ➝ ভোলা
            </p>
          </div>
        </div>
      </div>

      <div className="p-4 space-y-8 relative" data-id="element-304">
        {/* Vertical Line connecting steps */}
        <div className="absolute left-[27px] top-12 bottom-32 w-0.5 bg-gray-300 z-0 border-l-2 border-dashed border-gray-300" data-id="element-305" />

        {/* Step 1: Start */}
        <div className="relative z-10" data-id="element-306">
          <div className="flex items-center space-x-4 mb-4" data-id="element-307">
            <div className="w-6 h-6 bg-[#006a4e] rounded-full border-4 border-white shadow-sm flex-shrink-0" data-id="element-308" />
            <h2 className="text-lg font-bold text-gray-900 font-bengali" data-id="element-309">
              বাংলামটর থেকে শুরু
            </h2>
          </div>
        </div>

        {/* Step 2: Last Mile Selection */}
        <div className="relative z-10 pl-10" data-id="element-310">
          <div className="bg-white p-4 rounded-2xl shadow-sm border border-gray-200 mb-6" data-id="element-311">
            <div className="flex items-center justify-between mb-4" data-id="element-312">
              <h3 className="font-bold text-gray-800 font-bengali flex items-center" data-id="element-313">
                <Navigation size={18} className="mr-2 text-[#006a4e]" data-id="element-314" />
                সদরঘাট পৌঁছানোর উপায়
              </h3>
              <span className="text-xs bg-[#006a4e]/10 text-[#006a4e] px-2 py-1 rounded font-bengali" data-id="element-315">
                ১টি বেছে নিন
              </span>
            </div>

            <div className="space-y-3" data-id="element-316">
              {lastMileOptions.map(option => <TransportOption key={option.id} option={option} selected={selectedLastMile === option.id} onSelect={() => setSelectedLastMile(option.id)} data-id="element-317" />)}
            </div>
          </div>
        </div>

        {/* Step 3: Interchange */}
        <div className="relative z-10" data-id="element-318">
          <div className="flex items-center space-x-4 mb-4" data-id="element-319">
            <div className="w-6 h-6 bg-white border-4 border-gray-400 rounded-full flex-shrink-0" data-id="element-320" />
            <div data-id="element-321">
              <h2 className="text-lg font-bold text-gray-900 font-bengali" data-id="element-322">
                সদরঘাট লঞ্চ টার্মিনাল
              </h2>
              <p className="text-sm text-gray-500 font-bengali" data-id="element-323">
                পৌঁছানোর আনুমানিক সময়: ১০:৩০
              </p>
            </div>
          </div>
        </div>

        {/* Step 4: Ship Selection */}
        <div className="relative z-10 pl-10" data-id="element-324">
          <h3 className="font-bold text-gray-800 font-bengali mb-3 flex items-center" data-id="element-325">
            <span className="text-2xl mr-2" data-id="element-326">🚢</span>
            লঞ্চের সময়সূচী
          </h3>
          <div className="space-y-4" data-id="element-327">
            {shipSchedules.map(schedule => <TimetableCard key={schedule.id} schedule={schedule} onBook={() => navigate('/segment-details')} data-id="element-328" />)}
          </div>
        </div>

        {/* Step 5: Destination */}
        <div className="relative z-10" data-id="element-329">
          <div className="flex items-center space-x-4" data-id="element-330">
            <div className="w-6 h-6 bg-green-600 rounded-full border-4 border-white shadow-sm flex-shrink-0" data-id="element-331" />
            <h2 className="text-lg font-bold text-gray-900 font-bengali" data-id="element-332">
              ভোলা
            </h2>
          </div>
        </div>
      </div>

      {/* Bottom Summary Bar */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 shadow-lg z-40 max-w-[480px] mx-auto" data-id="element-333">
        <div className="flex justify-between items-center mb-3" data-id="element-334">
          <div data-id="element-335">
            <p className="text-xs text-gray-500 font-bengali" data-id="element-336">
              আনুমানিক মোট খরচ
            </p>
            <p className="text-xl font-bold text-[#006a4e] font-bengali" data-id="element-337">
              ৳{toBengaliNumeral(totalMinFare)} - ৳
              {toBengaliNumeral(totalMaxFare)}
            </p>
          </div>
          <div className="text-right" data-id="element-338">
            <p className="text-xs text-gray-500 font-bengali" data-id="element-339">মোট সময়</p>
            <p className="text-lg font-bold text-gray-900 font-bengali" data-id="element-340">
              ~৫ ঘণ্টা ৩০ মি
            </p>
          </div>
        </div>
        <button onClick={() => navigate('/segment-details')} className="w-full bg-[#006a4e] text-white py-3.5 rounded-xl font-bold text-lg font-bengali shadow-lg shadow-green-200" data-id="element-341">
          এই রুটে এগিয়ে যান
        </button>
      </div>
    </div>;
}